import {animateByClass} from '../Library/Animation';

const template = document.createElement('div');

template.classList.add('mask');

const defaults = {
    excludedCloseHandlers: [],
    onClose: () => {},
    onCloseBlocked: () => {},
    mobileOnly: false,
    closeOutside: true,
    animate: true,
    beforeClose: () => true,
    className: null,
};

/**
 * @param {{[excludedCloseHandlers]: (string|HTMLElement)[], [onClose]: function, [mobileOnly]: boolean, [closeOutside]: boolean, [animate]: boolean}} options
 */
export const Mask = (options) => {
    options = {...defaults, ...options};

    let mask = undefined;
    let mouseDownTarget = null;
    let listenerTimeout = null;

    const removeListeners = () => {
        clearTimeout(listenerTimeout);

        document.removeEventListener('mousedown', mouseDownHandler);
        document.removeEventListener('click', closeHandler);
        document.removeEventListener('touchend', closeTouchHandler);
    };

    const mouseDownHandler = (event) => {
        mouseDownTarget = event.target;
    };

    const closeHandler = (event) => {
        if (!options.closeOutside) {
            return;
        }

        if (!isCloseHandler(event.target) || !isCloseHandler(mouseDownTarget)) {
            return;
        }

        if (!options.beforeClose()) {
            options.onCloseBlocked();

            return;
        }

        hide();
    };

    const closeTouchHandler = (event) => {
        if (event.target.closest('body header .user-settings-toggle')) {
            hide();

            return;
        }

        if (!options.closeOutside) {
            return;
        }

        if (!event.target.closest('.mask')) {
            return;
        }

        if (!options.beforeClose()) {
            options.onCloseBlocked();

            return;
        }

        hide();
    };

    const isCloseHandler = (clickTarget) => {
        if (!clickTarget || !clickTarget.isConnected) {
            return false;
        }

        for (const handler of options.excludedCloseHandlers) {
            const element = handler instanceof HTMLElement ? handler : document.querySelector(handler);

            if (element && element.contains(clickTarget)) {
                return false;
            }
        }

        return true;
    };

    const render = async () => {
        const newMask = template.cloneNode();

        mask = newMask;

        if (options.mobileOnly) {
            newMask.classList.add('mobile-only');
        }

        if (options.className) {
            newMask.classList.add(options.className);
        }

        document.querySelector('body').appendChild(newMask);

        // defer registering the click handler to the next tick of the event loop
        listenerTimeout = setTimeout(() => {
            document.addEventListener('mousedown', mouseDownHandler);
            document.addEventListener('click', closeHandler);
            document.addEventListener('touchend', closeTouchHandler);
        }, 0);

        if (options.animate) {
            await animateByClass(newMask, 'show');
        }

        if (mask === newMask) {
            newMask.classList.add('active');
        }
    };

    const hide = async () => {
        if (!mask) {
            return;
        }

        const activeMask = mask;

        removeListeners();

        activeMask.classList.remove('active');

        options.onClose();

        if (options.animate) {
            await animateByClass(activeMask, 'hide');
        }

        if (mask !== activeMask) {
            return;
        }

        activeMask.remove();

        mask = undefined;
    };

    const reset = () => {
        removeListeners();

        const selector = options.className ? `.mask.${options.className}` : '.mask';

        document.querySelectorAll(selector).forEach(element => element.remove());

        mask            = undefined;
        mouseDownTarget = null;
    };

    return {
        render: render,
        hide: hide,
        reset: reset,
    };
};
